import { ReactNode } from 'react';
import styles from './iOSTheme.module.css';
import useIOSLayoutFix from './useIOSLayoutFix';

export interface IOSThemeProps {
  children: ReactNode;
  enable?: boolean;
}

const IOSTheme = ({ children, enable = false }: IOSThemeProps) => {
  useIOSLayoutFix(enable);

  return <div className={enable ? styles.iosTheme : ''}>{children}</div>;
};

export const isIOSThemeEnabled = () =>
  document.getElementsByClassName(styles.iosTheme).length > 0;
export default IOSTheme;
